"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importStar(require("react"));
var DueDate_1 = tslib_1.__importDefault(require("../DueDate"));
var ArrearsOnHold = function (props) {
    var aohTotal = props.aohTotal, reviewDate = props.reviewDate;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    return (react_1.default.createElement(asg_1.Box, { round: "8px", margin: { bottom: 'xsmall', top: responsiveSize === 'xs' ? '12px' : undefined }, width: "100%", background: asg_1.colors.white, pad: { vertical: 'xsmall', horizontal: responsiveSize === 'xs' ? 'medium' : 'small' }, border: { size: '1px', color: asg_1.colors['grey-3'] } },
        react_1.default.createElement(asg_1.Box, { direction: "row" },
            react_1.default.createElement(asg_1.Box, { width: "60%" },
                react_1.default.createElement(asg_1.Text, { size: "small", "data-testid": "aohTotalLabel", weight: 600 }, "Arrears on hold"),
                react_1.default.createElement(DueDate_1.default, { dueDate: reviewDate, hasDirectDebitSetup: true, hasArrearsOnHoldSetup: true })),
            react_1.default.createElement(asg_1.Box, { width: "40%", direction: "row", alignSelf: "start" },
                react_1.default.createElement(asg_1.Text, { width: "100%", alignSelf: "center", textAlign: "end", size: "medium", "data-testid": "aohTotalAmt", weight: 600 },
                    "$",
                    aohTotal.toFixed(2))))));
};
exports.default = ArrearsOnHold;
//# sourceMappingURL=ArrearsOnHold.js.map